/* unplugin-vue-components disabled */import { render } from "./ProductTable.vue?vue&type=template&id=043c5976&scoped=true&ts=true"
import script from "./ProductTable.vue?vue&type=script&lang=ts"
export * from "./ProductTable.vue?vue&type=script&lang=ts"

import "./ProductTable.vue?vue&type=style&index=0&id=043c5976&scoped=true&lang=scss"
import "./ProductTable.vue?vue&type=style&index=1&id=043c5976&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043c5976"]])

export default __exports__